import React from 'react'
import HeadingTexts from './../../common/HeadingTexts';
import lab1 from "../../../Assets/Home/Lab/lab1.png";
import lab2 from "../../../Assets/Home/Lab/lab2.png";
import lab3 from "../../../Assets/Home/Lab/lab3.png";
import lab4 from "../../../Assets/Home/Lab/lab4.png";
import lab5 from "../../../Assets/Home/Lab/lab5.svg";

const OurCenters = () => {

  const centersData = [
    { name: "Kalinga Nagar", image: lab1 },
    { name: "Near AIIMS Hospital", image: lab2 },
    { name: "Nayapali", image: lab3 },
    { name: "Balianta", image: lab4 },
    { name: "Saheed Nagar", image: lab5 },
  ]

  return (
    <section className="bg-[#fafafa] md:px-10 px-6 pt-10 md:pb-20 pb-14">
      <HeadingTexts
        label="Our Authorised Collection Centers"
        text="Bhubaneswar, Odisha"
        // bluetext=" Centers"
        position={'center'}
      />
      {/* Collection Centers Section */}
      <div className="grid md:grid-cols-2 lg:grid-cols-5 mt-10 gap-8">
        {centersData.map((center, index) => (
          <div
            key={index}
            data-aos="flip-down"
            className="lab-card bg-white flex flex-col items-center space-y-4 rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 ease-in-out px-4 sm:px-3 md:px-5 py-2 sm:py-3"
          >
            <img
              src={center.image}
              alt={center.name}
              sizes={30}
            />
            <h3 className="text-lg md:text-xl font-semibold text-gray-800">
              {center.name}
            </h3>
          </div>
        ))}
      </div>

    </section>
  )
}

export default OurCenters